<template>
    <div>
        <div id="echart-line-history" :style="{ width: '750px', height: '450px' }"></div>
        <div id="echart-line-realtime" :style="{ width: '750px', height: '450px' }"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    methods: {
        initChart(nameHistory, xDataHistory, yDataHistory, nameRealtime = '', xDataRealtime = [], yDataRealtime = { price: [], netvalue: [], small: [], middle: [], big: [], super: [] }) {
            // 简单的折线教程：https://blog.csdn.net/qq_44182284/article/details/106050398
            // 多个Y轴的教程：https://blog.csdn.net/weixin_45884508/article/details/126159227
            // 数据示例如下：
            // xDataHistory = ['2022/10/10', '2022/10/11', '2022/10/12', '2022/10/13', '2022/10/14', '2022/10/17', '2022/10/18', '2022/10/19', '2022/10/20', '2022/10/21', '2022/10/24', '2022/10/25', '2022/10/26', '2022/10/27', '2022/10/28', '2022/10/31', '2022/11/1', '2022/11/2', '2022/11/3', '2022/11/4', '2022/11/7', '2022/11/8', '2022/11/9', '2022/11/10', '2022/11/11', '2022/11/14', '2022/11/15', '2022/11/16', '2022/11/17', '2022/11/18', '2022/11/21', '2022/11/22', '2022/11/23', '2022/11/24']
            // yDataHistory = {
            //     price: [22.01,21.56,21.6,21.7,22.63,22.53,23.9,23.25,24.21,25.01,25.28,24.28,25.98,28.58,28.08,30.48,33.05,32.16,32.03,34.93,33.57,32.8,35,34.48,31.21,34.33,37.76,39.66,43.63,46.28,46,43.18,39.99,43.99],
            //     netvalue: [60016233, -41375850, -88210086, -111944751, 949957, -75417624, 16993003, -45112082, 124453677, 183275997, 250246333, 156986364, 212127244, 662505644, 383010716, 452499996, 479324092, 434383996, 313788652, 849794028, 258448524, 70870908, 240080908, 193358108, -539639684, 507718732, 405712236, -995368004, -828088692, -1318764484, -1945355796, -2804384180, -2966442436, -2692037460],
            //     small: [-37446336, 45166498, 63529019, 95504633, 48846553, 105751712, 2521648, 67616128, -80851296, -135878208, -186470816, -115740704, -193629776, -448736560, -307894944, -372739952, -384586560, -328283056, -204420288, -404793664, -65443664, 61292928, -8114768, 83423744, 611812176, 80041776, 187663984, 1226882608, 1127957728, 1408952448, 1760674336, 2467369408, 2661124656, 2482457040],
            //     middle: [22.01, 21.56, 21.6, 21.7, 22.63, 22.53, 23.9, 23.25, 24.21, 25.01, 25.28, 24.28, 25.98, 28.58, 28.08, 30.48, 33.05, 32.16, 32.03, 34.93, 33.57, 32.8, 35, 34.48, 31.21, 34.33, 37.76, 39.66, 43.63, 46.28, 46, 43.18, 39.99, 43.99],
            //     big: [72171520, 52963097, 29266442, 1329324, 52148492, 18076446, 69483294, 55850522, 151930538, 187277002, 308657850, 292283530, 285322922, 294101802, 278706490, 271305626, 215671770, 125132122, 81641370, 16228634, -284704694, -362494550, -187859302, -136693014, -350311734, -194313078, -257189622, -499691046, -754668406, -764021334, -802042342, -833296966, -960892326, -1516188518],
            //     super: [-12155287, -94338947, -117476528, -113274075, -51198535, -93494070, -52490291, -100962604, -27476861, -4001005, -58411517, -135297166, -73195678, 368403842, 104304226, 181194370, 263652322, 309251874, 232147282, 833565394, 543153218, 433365458, 427940210, 330051122, -189327950, 702031810, 662901858, -495676958, -73420286, -554743150, -1143313454, -1971087214, -2005550110, -1175848942]
            // }
            let chartHistory = echarts.init(document.getElementById('echart-line-history'));
            let chartRealtime = echarts.init(document.getElementById('echart-line-realtime'));
            var optionHistory = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [nameHistory],
                    bottom: '0%'
                },
                grid: { //调整图表上下左右位置
                    top: '10%',
                    left: '3%',
                    right: '8%',
                    bottom: '11%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xDataHistory
                },
                yAxis: [{
                    type: 'value',
                    name: '价格',
                    min: Math.min(yDataHistory.price),
                    max: Math.max(yDataHistory.price),
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'blue',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: 'blue',
                        },
                    },
                }, {
                    type: 'value',
                    name: "资金流入",
                    position: 'right',
                    axisLabel: {
                        textStyle: {
                            color: 'red',
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'red'
                        }
                    },
                },],
                series: [
                    {
                        name: '股价',
                        type: 'line',
                        data: yDataHistory.price,
                        yAxisIndex: 0,//对应左侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#829a20',
                                lineStyle: {
                                    color: '#829a20' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '主力净流入',
                        type: 'line',
                        data: yDataHistory.netvalue,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#ea55db',
                                lineStyle: {
                                    color: '#ea55db' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '小单',
                        type: 'line',
                        data: yDataHistory.small,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#9dc4ea',
                                lineStyle: {
                                    color: '#9dc4ea' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '中单',
                        type: 'line',
                        data: yDataHistory.middle,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#f5ba57',
                                lineStyle: {
                                    color: '#f5ba57' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '大单',
                        type: 'line',
                        data: yDataHistory.big,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#eb362c',
                                lineStyle: {
                                    color: '#eb362c' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '超大单',
                        type: 'line',
                        data: yDataHistory.super,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#5c0e07',
                                lineStyle: {
                                    color: '#5c0e07' //改变折线颜色
                                }
                            }
                        },
                    },
                ]
            };
            var optionRealtime = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: [nameRealtime],
                    bottom: '0%'
                },
                grid: { //调整图表上下左右位置
                    top: '10%',
                    left: '3%',
                    right: '8%',
                    bottom: '11%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xDataRealtime
                },
                yAxis: [{
                    type: 'value',
                    name: '价格',
                    min: Math.min(yDataRealtime.price),
                    max: Math.max(yDataRealtime.price),
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'blue',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: 'blue',
                        },
                    },
                }, {
                    type: 'value',
                    name: "资金流入",
                    position: 'right',
                    axisLabel: {
                        textStyle: {
                            color: 'red',
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'red'
                        }
                    },
                },],
                series: [
                    {
                        name: '股价',
                        type: 'line',
                        data: yDataRealtime.price,
                        yAxisIndex: 0,//对应左侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#829a20',
                                lineStyle: {
                                    color: '#829a20' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '主力净流入',
                        type: 'line',
                        data: yDataRealtime.netvalue,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#ea55db',
                                lineStyle: {
                                    color: '#ea55db' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '小单',
                        type: 'line',
                        data: yDataRealtime.small,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#9dc4ea',
                                lineStyle: {
                                    color: '#9dc4ea' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '中单',
                        type: 'line',
                        data: yDataRealtime.middle,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#f5ba57',
                                lineStyle: {
                                    color: '#f5ba57' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '大单',
                        type: 'line',
                        data: yDataRealtime.big,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#eb362c',
                                lineStyle: {
                                    color: '#eb362c' //改变折线颜色
                                }
                            }
                        },
                    },
                    {
                        name: '超大单',
                        type: 'line',
                        data: yDataRealtime.super,
                        yAxisIndex: 1,//对应右侧的y轴
                        symbol: "none",
                        itemStyle: {
                            normal: {
                                color: '#5c0e07',
                                lineStyle: {
                                    color: '#5c0e07' //改变折线颜色
                                }
                            }
                        },
                    },
                ]
            };

            chartHistory.setOption(optionHistory);
            chartRealtime.setOption(optionRealtime);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                chartHistory.resize();
                chartRealtime.resize();
            });
        },
    }
}
</script>
